import ShopType from "@/enum/ShopType";
import OrderTableColumnsType from "@/scenes/OrderManagement/enum/OrderTableColumnsType";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import type { OrderTableColumn } from "@/scenes/OrderManagement/store/OrderTableStorageStore/utils/orderTableColumns";

export function getOrderTablePurchaserName(shopType: ShopType) {
    if (
        [
            ShopType.DOUDIAN_IOP,
            ShopType.PDD_FDS,
            ShopType.ALIBABA_SUPPLIER,
            ShopType.KWAI_DROPSHIP,
            ShopType.CHANNEL_SHOP_DROPSHIP,
            ShopType.CHANNEL_SHOP_SUPPLIER,
        ].includes(shopType)
    ) {
        return "代理商昵称";
    }

    return "买家昵称";
}

export function getOrderTablePayTimeName(shopType: ShopType) {
    if (shopType === ShopType.DOUDIAN_SUPPLIER) {
        return "买家付款时间";
    }

    return "付款时间";
}

export function isOrderTableColumnRenderable(type: OrderTableColumnsType, tab?: OrderTab) {
    if ([OrderTableColumnsType.LOGISTICS_AGING_PREDICT, OrderTableColumnsType.LOGISTICS_RECOMMEND].includes(type)) {
        return tab === OrderTab.PENDING_SHIPMENT;
    }

    return true;
}

export function getRenderableOrderTableColumns(columns: OrderTableColumn[], tab?: OrderTab) {
    return columns.filter(({ type }) => isOrderTableColumnRenderable(type, tab));
}
